import React, { useEffect, useState } from "react";
import "./Hero.css";

// 👉 Import your images
  import img1 from "../../assets/images/projects/img.jpg";
  import img2 from "../../assets/roger-starnes-sr-1j1kPS0vZqA-unsplash.jpg";
  import img3 from "../../assets/images/projects/img2.webp";
  import logo from "../../assets/images/logo/jayaramlog.png";





    import img4 from "../../assets/baner1.jpeg";
  import img5 from "../../assets/baner2.jpeg";
  import img6 from "../../assets/baner3.jpeg";

    import img7 from "../../assets/baner4.jpeg";
  import img8 from "../../assets/baner5.jpeg";
const Hero = () => {
  const images = [img4, img5, img6,img7,img8];

  const [current, setCurrent] = useState(0);

  // 🔁 Auto slide every 4 sec
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section id="home" className="hero">
      {/* SLIDES */}
      {images.map((img, index) => (
        <div
          key={index}
          className={`hero-slide ${index === current ? "active" : ""}`}
        >
          <img src={img} alt={`slide-${index}`} />
        </div>
      ))}

      {/* OVERLAY */}
      <div className="hero-overlay"></div>

      
    </section>
  );
};

export default Hero;